import Model from '@/lib/data/Model';
import RiskForm from './RiskForm';

class RiskSection extends Model {
    fields = [
        'name',
        'type',
        'average_mgw',
        'average_gw',
        {
            name: 'average_point',
            type: 'float',
            getter(v) {
                return Math.floor(v * 10000) / 100;
            },
        },
        {
            name: 'tabwert',
            type: 'float',
            getter(v) {
                return Math.floor(v * 10000) / 100;
            },
        },
        {
            name: 'reduction',
            type: 'float',
            getter(v) {
                return Math.floor(v * 10000) / 100;
            },
        },
        {
            name: 'risk_rank',
            type: 'float',
            getter(v) {
                return Math.floor(v * 10000) / 100;
            },
        },
        {
            name: 'forms',
            association: {
                type: 'many',
                model: RiskForm,
            },
        },
    ];

    /**
     * Create the RiskSection object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data);
        this.init();
    }
}

export default RiskSection;
